import { Button } from "@/components/ui/button/button";
import { Link } from "react-router-dom";
import { GoReport } from "react-icons/go";

export const HomeMonthlyReportCard = () => {
  return (
    <div className="w-60 h-24 rounded-md bg-card flex flex-col gap-1 shadow-sm border p-4">
      <div className="flex flex-row items-center pb-2 justify-between">
        <h2 className="text-sm font-medium">Monthly Report</h2>

        <GoReport className="w-4 h-4" />
      </div>
      <div className="">
        <Button variant="default" asChild size="sm">
          <Link to="/admin/employees/monthly-report">View</Link>
        </Button>
      </div>
    </div>
  );
};
